import React, { useEffect, useState } from "react";
import { useFormikContext } from "formik";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

import CheckboxGroup from "components/InputsField/formikInputs/CheckboxGroup";
import { onlyNumberInput } from "components/InputsField/inputFormats";
import { FreightsDropdowns } from "service/dropdownServices/FreightsDropdowns";
import FormikTextField from "components/InputsField/formikInputs/FormikTextField";
import FormikCheckboxField from "components/InputsField/formikInputs/FormikCheckboxField";
import AsyncSelect from "components/InputsField/formikInputs/AsyncSelect";
import Title from "components/common/Layout/Title";
import FormRow from "components/common/Layout/FormRow";
import Label from "components/InputsField/Label";

import styles from "./styles.module.scss";
import { UTILS } from "endpointsConst";

export default function FreightsTransport() {
    const [loadingOptions, setLoadingOptions] = useState([]);
    const [unloadingOptions, setUnloadingOptions] = useState([]);
    const { initialValues } = useFormikContext();
    const { t } = useTranslation();
    const lang = useSelector((state) => state.settings.lang);

    const getTranslate = (str) => t("cargoFields.transport_section." + str);

    useEffect(() => {
        FreightsDropdowns.getLoadingTypes(lang)
            .then((res) => {
                let loadingOptions = res.data.map((el) => {
                    return {
                        label: el.value,
                        value: el.id,
                    };
                });
                setLoadingOptions(loadingOptions);
            })
            .catch((e) => {
                console.log(e.response);
            });

        FreightsDropdowns.getUnloadingTypes(lang)
            .then((res) => {
                let unloadingOptions = res.data.map((el) => {
                    return {
                        label: el.value,
                        value: el.id,
                    };
                });
                setUnloadingOptions(unloadingOptions);
            })
            .catch((e) => {
                console.log(e.response);
            });
    }, [lang]);

    return (
        <>
            <Title withMargin>{getTranslate("heading")}</Title>
            <FormRow>
                <AsyncSelect
                    name="transport_bodytype_ids"
                    label={getTranslate("body")}
                    url={`${UTILS}/transport-bodytypes/?lang=${lang}`}
                    placeholder={initialValues.bodytype || ""}
                    required
                    sort
                    isMulti
                />
                <div className={styles.numberRow}>
                    <FormikTextField
                        name="car_count"
                        label={getTranslate("number")}
                        maxLength="2"
                        placeholder=""
                        format={onlyNumberInput}
                        wrapperClassName={styles.number}
                    />
                    <div className={styles.checkboxRow}>
                        <CheckboxGroup
                            checkboxes={[
                                <FormikCheckboxField
                                    name="hitch"
                                    id="hitch"
                                    label={getTranslate("coupling_box")}
                                />,
                                <FormikCheckboxField
                                    name="air_passage"
                                    id="air_passage"
                                    label={getTranslate("compressed_air_box")}
                                />,
                                <FormikCheckboxField
                                    name="conics"
                                    id="conics"
                                    label={getTranslate("bolster_box")}
                                />,
                            ]}
                        />
                    </div>
                </div>
            </FormRow>

            <FormRow withMargin>
                <AsyncSelect
                    name="loading_types_ids"
                    options={loadingOptions}
                    label={getTranslate("loading")}
                    placeholder=""
                    isMulti
                />
                <AsyncSelect
                    name="unloading_types_ids"
                    options={unloadingOptions}
                    label={getTranslate("unloading")}
                    placeholder=""
                    isMulti
                />
            </FormRow>
            <FormRow withMargin>
                <div>
                    <Label label={getTranslate("document")} />
                    <div className={styles.checkboxRow}>
                        <CheckboxGroup
                            checkboxes={[
                                <FormikCheckboxField name="TIR" id="TIR" label="TIR" />,
                                <FormikCheckboxField name="CMR" id="CMR" label="CMR" />,
                                <FormikCheckboxField name="T1" id="T1" label="T1" />,
                                <FormikCheckboxField
                                    name="medical_book"
                                    id="medical_book"
                                    label={getTranslate("permit_box")}
                                />,
                            ]}
                        />
                    </div>
                </div>
            </FormRow>
            <FormRow withMargin>
                <div>
                    <Label label={getTranslate("gps_tracking_label")} />
                    <FormikCheckboxField
                        name="gps_tracking"
                        id="gps_tracking"
                        label={getTranslate("gps_tracking_box")}
                    />
                </div>
            </FormRow>
        </>
    );
}
